import React from 'react';
import { ShieldCheck, RefreshCw, Phone } from 'lucide-react';
export function TrustBoxSection() {
  return <section className="bg-white border-y border-gray-100 py-6" data-id="element-612">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-613">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center justify-center text-center md:text-left" data-id="element-614">
          {/* Warranty */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-3" data-id="element-615">
            <div className="bg-brand-yellow/10 p-2 rounded-full flex-shrink-0" data-id="element-616">
              <ShieldCheck className="h-5 w-5 text-brand-yellow" data-id="element-617" />
            </div>
            <div data-id="element-618">
              <h3 className="font-bold text-brand-dark text-sm uppercase tracking-wide" data-id="element-619">
                1-Year Limited Warranty
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-620">
                Pump, motor, and housing covered
              </p>
            </div>
          </div>

          {/* Returns */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-3" data-id="element-621">
            <div className="bg-brand-yellow/10 p-2 rounded-full flex-shrink-0" data-id="element-622">
              <RefreshCw className="h-5 w-5 text-brand-yellow" data-id="element-623" />
            </div>
            <div data-id="element-624">
              <h3 className="font-bold text-brand-dark text-sm uppercase tracking-wide" data-id="element-625">
                30-Day Returns
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-626">
                Unused items in original packaging
              </p>
            </div>
          </div>

          {/* Support */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-3" data-id="element-627">
            <div className="bg-brand-yellow/10 p-2 rounded-full flex-shrink-0" data-id="element-628">
              <Phone className="h-5 w-5 text-brand-yellow" data-id="element-629" />
            </div>
            <div data-id="element-630">
              <h3 className="font-bold text-brand-dark text-sm uppercase tracking-wide" data-id="element-631">
                Direct Support
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-632">Call or text 810-818-5941</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}